import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, isRef as _isRef, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, vModelSelect as _vModelSelect } from "vue"
import _imports_0 from '../assets/logo.png'
import _imports_1 from '../assets/language.png'


const _hoisted_1 = { class: "header-container" }
const _hoisted_2 = { class: "header-content" }
const _hoisted_3 = {
  key: 0,
  class: "mobile-language-selector"
}
const _hoisted_4 = { class: "language-selector-wrapper" }
const _hoisted_5 = { class: "language-dropdown-container" }
const _hoisted_6 = { class: "dropdown-menu" }
const _hoisted_7 = {
  key: 0,
  class: "dropdown-submenu"
}
const _hoisted_8 = ["onClick"]
const _hoisted_9 = { class: "dropdown-submenu-content" }
const _hoisted_10 = {
  key: 0,
  class: "language-selector"
}
const _hoisted_11 = { class: "language-dropdown-container" }

import {ref, onMounted, onUnmounted, reactive, computed} from 'vue';
import {RouterLink, onBeforeRouteLeave, useRouter, useRoute} from 'vue-router';
import {useI18n} from 'vue-i18n';
import './../styles/GloablHeader.scss';

// 使用i18n
interface Category {
  id: number;
  parentId: number;
  menuName: string;
  menuNameEn: string;
  menuOrder: number;
  children: Category[] | null;
}


export default /*@__PURE__*/_defineComponent({
  __name: 'GloablHeader',
  setup(__props) {

const {locale, t} = useI18n();

// 控制导航菜单的显示状态
const isNavOpen = ref(false);
// 判断是否为移动设备
const isMobile = ref(false);
// 控制下拉菜单的显示状态
const dropdownOpen = reactive({
  product: false
});

// 存储产品分类数据
const productCategories = ref<Category[]>([]);

// 获取路由实例和当前路由
const router = useRouter();
const route = useRoute();

// 添加导航到首页的函数
function goToHome() {
  router.push('/');
}

// 计算属性：检测当前路由是否为产品分类下的路由
const isProductRouteActive = computed(() => {
  const currentRoute = route.path;
  // 检查当前路由是否包含产品ID路径
  return currentRoute.startsWith('/product/') ||
      ['/electric-motorcycles', '/motorcycle-parts', '/battery-exchange', '/ev-chargers', '/ev-cables', '/ev-adapters'].includes(currentRoute);
});

// 获取产品分类数据
async function fetchProductCategories() {
  try {
    // const response = await fetch('http://172.16.10.48:8080/jeecg-boot/drmotoev/menu/get');
    const response = await fetch('/jeecg-boot/drmotoev/menu/get');

    const data = await response.json();
    if (data.code === 200 && data.result) {
      // 根据menuOrder排序
      productCategories.value = data.result.sort((a: Category, b: Category) => a.menuOrder - b.menuOrder);
    }
    console.log("~~~~~~~~~~~~~~~productCategories：", productCategories.value)
  } catch (error) {
    console.error('获取产品分类数据失败:', error);
    // 为了演示效果，添加模拟数据（根据用户提供的接口示例更新）
    productCategories.value = [
      {
        id: 1,
        parentId: 0,
        menuName: "AA",
        menuNameEn: "aa",
        menuOrder: 0,
        children: [
          {
            id: 2,
            parentId: 1,
            menuName: "SS",
            menuNameEn: "ss",
            menuOrder: 1,
            children: null
          }
        ]
      },
      {
        id: 3,
        parentId: 0,
        menuName: "DD",
        menuNameEn: "dd",
        menuOrder: 1,
        children: null
      }
    ];
  }
}

// 切换导航菜单显示/隐藏
function toggleMenu() {
  if (isNavOpen.value) {
    isNavOpen.value = false;

    // 在动画结束后再重置其他状态
    setTimeout(() => {
      // 仅在非移动设备上重置下拉菜单状态
      if (!isMobile.value) {
        Object.keys(dropdownOpen).forEach(key => {
          dropdownOpen[key as keyof typeof dropdownOpen] = false;
        });
      }
    }, 400);
  } else {
    // 打开菜单时的逻辑
    isNavOpen.value = true;

    // 在移动设备上，当菜单打开时自动展开所有下拉菜单
    if (isMobile.value) {
      Object.keys(dropdownOpen).forEach(key => {
        dropdownOpen[key as keyof typeof dropdownOpen] = true;
      });
    }
  }
}

// 打开下拉菜单
function openDropdown(type: string) {
  dropdownOpen[type as keyof typeof dropdownOpen] = true;
}

// 关闭下拉菜单
function closeDropdown(type: string) {
  // 在移动设备上不允许关闭下拉菜单
  if (!isMobile.value) {
    setTimeout(() => {
      dropdownOpen[type as keyof typeof dropdownOpen] = false;
    }, 200);
  }
}
    // 处理带有子菜单的一级分类点击事件
    function handleParentCategoryClick(category: Category) {
      // 导航到一级分类自身的内容
      router.push({
        name: 'TopicDetail', 
        query: {
          topicId: category.id,  // 使用一级分类的ID
          from: 'category',
          isParentCategory: 'true'  // 添加标记，表示这是从一级分类点击过来的
        }
      });
      handleCategoryClick(); // 调用通用的分类点击处理逻辑
    }

// 切换下拉菜单状态 - 修复：移除移动设备限制
function toggleDropdown(type: string) {
  dropdownOpen[type as keyof typeof dropdownOpen] = !dropdownOpen[type as keyof typeof dropdownOpen];
}

// 处理分类点击事件，确保导航后菜单状态正确
function handleCategoryClick() {
  if (!isMobile.value) {
    // 在桌面设备上点击分类后关闭下拉菜单
    dropdownOpen.product = false;
  }
  // 在移动设备上保持菜单打开状态
}

// 检查屏幕尺寸，更新isMobile状态
function checkScreenSize() {
  isMobile.value = window.innerWidth <= 768;
  // 如果窗口宽度大于768px，强制关闭导航菜单和下拉菜单
  if (window.innerWidth > 768) {
    isNavOpen.value = false;
    Object.keys(dropdownOpen).forEach(key => {
      dropdownOpen[key as keyof typeof dropdownOpen] = false;
    });
    document.body.style.overflow = '';
  }
}

// 在路由离开前关闭菜单
onBeforeRouteLeave((to, from, next) => {
  if (isNavOpen.value) {
    isNavOpen.value = false;
    document.body.style.overflow = '';

    // 在非移动设备上也重置下拉菜单状态
    Object.keys(dropdownOpen).forEach(key => {
      dropdownOpen[key as keyof typeof dropdownOpen] = false;
    });
  }
  next();
});

// 处理点击其他区域关闭菜单 - 修复类型注解
function handleClickOutside(event: MouseEvent): void {
  const target = event.target as HTMLElement;
  const menuContainer = document.querySelector('.nav-container') as HTMLElement | null;
  const menuToggle = document.querySelector('.menu-toggle') as HTMLElement | null;
  
  // 检查是否点击在菜单或菜单按钮外
  if (menuContainer && menuToggle && 
      !menuContainer.contains(target) && 
      !menuToggle.contains(target)) {
    
    // 关闭导航菜单
    if (isNavOpen.value) {
      isNavOpen.value = false;
      
      // 重置下拉菜单状态
      setTimeout(() => {
        Object.keys(dropdownOpen).forEach(key => {
          dropdownOpen[key as keyof typeof dropdownOpen] = false;
        });
        document.body.style.overflow = '';
      }, 400);
    } else {
      // 如果菜单已经关闭，只重置下拉菜单
      Object.keys(dropdownOpen).forEach(key => {
        dropdownOpen[key as keyof typeof dropdownOpen] = false;
      });
    }
  }
}

// 定义事件处理函数引用
let clickOutsideHandler: (event: MouseEvent) => void;
let resizeHandler: () => void;
let routeChangeHandler: () => void;
let removeRouteListener: () => void;

// 监听窗口大小变化和路由变化
onMounted(() => {
  // 初始化处理函数
  clickOutsideHandler = handleClickOutside;
  resizeHandler = checkScreenSize;
  routeChangeHandler = () => {
    if (isNavOpen.value) {
      isNavOpen.value = false;
      document.body.style.overflow = '';

      // 重置下拉菜单状态
      Object.keys(dropdownOpen).forEach(key => {
        dropdownOpen[key as keyof typeof dropdownOpen] = false;
      });
    }
  };
  
  checkScreenSize();
  window.addEventListener('resize', resizeHandler);
  document.addEventListener('click', clickOutsideHandler);

  // 获取产品分类数据
  fetchProductCategories();

  // 添加路由变化监听
  removeRouteListener = router.afterEach(routeChangeHandler);
});

// 组件卸载时移除事件监听 - 修复事件监听移除逻辑
onUnmounted(() => {
  window.removeEventListener('resize', resizeHandler);
  document.removeEventListener('click', clickOutsideHandler);
  document.body.style.overflow = '';
  
  // 移除路由监听器
  if (removeRouteListener) {
    removeRouteListener();
  }
});

return (_ctx: any,_cache: any) => {
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isMobile.value && isNavOpen.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "menu-overlay",
          onClick: toggleMenu
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", { class: "logo-container" }, [
        _createElementVNode("img", {
          src: _imports_0,
          alt: "Dr.Motor Logo",
          class: "logo-image",
          onClick: goToHome
        })
      ]),
      (isMobile.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _cache[7] || (_cache[7] = _createElementVNode("img", {
                  src: _imports_1,
                  alt: "Language",
                  class: "language-dropdown-icon"
                }, null, -1)),
                _createVNode(_component_el_select, {
                  modelValue: _unref(locale),
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (_isRef(locale) ? (locale).value = $event : null)),
                  size: "small",
                  class: "custom-language-select"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_option, { value: "zh-Hant" }, {
                      default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                        _createElementVNode("div", { class: "language-option" }, [
                          _createElementVNode("span", { class: "language-icon" }, "🇹🇼"),
                          _createElementVNode("span", { class: "language-text" }, "繁中")
                        ], -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_el_option, { value: "en" }, {
                      default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                        _createElementVNode("div", { class: "language-option" }, [
                          _createElementVNode("span", { class: "language-icon" }, "🇬🇧"),
                          _createElementVNode("span", { class: "language-text" }, "English")
                        ], -1)
                      ]))]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ])
          ]))
        : _createCommentVNode("", true),
      (isMobile.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 1,
            class: "menu-toggle",
            onClick: toggleMenu
          }, [...(_cache[8] || (_cache[8] = [
            _createElementVNode("div", { class: "menu-icon" }, [
              _createElementVNode("span", { class: "menu-line" }),
              _createElementVNode("span", { class: "menu-line" }),
              _createElementVNode("span", { class: "menu-line" })
            ], -1)
          ]))]))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(["nav-container", { 'nav-open': isNavOpen.value }]),
        style: {"z-index":"9999"}
      }, [
        _createVNode(_unref(RouterLink), {
          to: "/",
          class: "nav-item",
          "active-class": "active",
          exact: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('home')), 1)
          ]),
          _: 1
        }),
        _createElementVNode("div", {
          class: _normalizeClass(["nav-item dropdown", { 'active': isProductRouteActive.value }]),
          onMouseenter: _cache[2] || (_cache[2] = ($event: any) => (openDropdown('product'))),
          onMouseleave: _cache[3] || (_cache[3] = ($event: any) => (closeDropdown('product')))
        }, [
          _createElementVNode("div", {
            class: "dropdown-toggle",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (toggleDropdown('product')))
          }, [
            _createTextVNode(_toDisplayString(_unref(t)('productCategory')) + " ", 1),
            _cache[9] || (_cache[9] = _createElementVNode("span", { class: "dropdown-arrow" }, "▼", -1))
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_6, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(productCategories.value, (category) => {
              return (_openBlock(), _createElementBlock(_Fragment, {
                key: category.id
              }, [
                (category.children && category.children.length > 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["dropdown-submenu-toggle", { 'active': _unref(route).query.topicId === category.id.toString() }]),
                        onClick: ($event: any) => (handleParentCategoryClick(category))
                      }, [
                        _createTextVNode(_toDisplayString(_unref(locale) === 'en' ? category.menuNameEn : category.menuName) + " ", 1),
                        _cache[10] || (_cache[10] = _createElementVNode("span", { class: "dropdown-submenu-arrow" }, "▶", -1))
                      ], 10, _hoisted_8),
                      _createElementVNode("div", _hoisted_9, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(category.children, (subCategory) => {
                          return (_openBlock(), _createBlock(_unref(RouterLink), {
                            key: subCategory.id,
                            to: { name: 'TopicDetail', query: { topicId: subCategory.id, from: 'category' } },
                            class: _normalizeClass(["dropdown-item", { 'active': _unref(route).query.topicId === subCategory.id.toString() }]),
                            onClick: handleCategoryClick
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_unref(locale) === 'en' ? subCategory.menuNameEn : subCategory.menuName), 1)
                            ]),
                            _: 2
                          }, 1032, ["to", "class"]))
                        }), 128))
                      ])
                    ]))
                  : (_openBlock(), _createBlock(_unref(RouterLink), {
                      key: 1,
                      to: { name: 'TopicDetail', query: { topicId: category.id, from: 'category' } },
                      class: _normalizeClass(["dropdown-item", { 'active': _unref(route).query.topicId === category.id.toString() }]),
                      onClick: handleCategoryClick
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_unref(locale) === 'en' ? category.menuNameEn : category.menuName), 1)
                      ]),
                      _: 2
                    }, 1032, ["to", "class"]))
              ], 64))
            }), 128))
          ], 512), [
            [_vShow, dropdownOpen.product]
          ])
        ], 34),
        _createVNode(_unref(RouterLink), {
          to: "/contact",
          class: "nav-item",
          "active-class": "active",
          exact: ""
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_unref(t)('contactUs')), 1)
          ]),
          _: 1
        }),
        (!isMobile.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _cache[12] || (_cache[12] = _createElementVNode("img", {
                  src: _imports_1,
                  alt: "Language",
                  class: "language-dropdown-icon"
                }, null, -1)),
                _withDirectives(_createElementVNode("select", {
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(locale) ? (locale).value = $event : null)),
                  class: "language-dropdown"
                }, [...(_cache[11] || (_cache[11] = [
                  _createElementVNode("option", { value: "zh-Hant" }, [
                    _createElementVNode("span", { class: "language-icon" }, "🇹🇼"),
                    _createTextVNode(" 繁中 ")
                  ], -1),
                  _createElementVNode("option", { value: "en" }, [
                    _createElementVNode("span", { class: "language-icon" }, "🇬🇧"),
                    _createTextVNode(" English ")
                  ], -1)
                ]))], 512), [
                  [_vModelSelect, _unref(locale)]
                ])
              ])
            ]))
          : _createCommentVNode("", true)
      ], 2)
    ])
  ]))
}
}

})